function sendTriggerbeeConsent(email, name, title, consentText)
{
	mtr_custom.session = mtr_custom.session || {};

	mtr_custom.session.email = email;
	mtr_custom.session.name = name ? name : 'Unnamed';
	mtr.goal('Consent to Email Back');
	window.mtr_custom = mtr_custom; // Make sure the mtr_custom object is accessible in the global space by the mtr-logger
	if (window.mtr_custom.session.email) {
		window.mtr_consent.logConsent(title, consentText);
		console.log('consent sent to Triggerbee');
	} else {
		console.log('No user email filled up');
	}
}

function waitForMtr(callback) {
	var isReady = typeof window.mtr !== "undefined" &&
		typeof window.mtr_consent !== "undefined";
	if (isReady)
	{
		callback();
	}
	else
	{
		setTimeout(function () {
			waitForMtr(callback);
		}, 250);
	}
}

window.waitForMtr = waitForMtr;
window.sendTriggerbeeConsent = sendTriggerbeeConsent;

document.addEventListener("DOMContentLoaded", function(event) {

	var menuButton = document.getElementById('mobile-menu-button');
	var menu = document.getElementById('js-main-menu');
	var clicked = false;

	menuButton.onclick = function() {

		if ( clicked == false ) {
			setTimeout(function(){
				menu.classList.add('active');
				menuButton.classList.add('active');
				clicked = true;
			}, 150);
		} else {
			closeMenu();
		}
	}

	document.onkeydown = function(evt) {
	    evt = evt || window.event;
	    if ( evt.keyCode == 27 && menu.classList.contains('active') ) {
	        closeMenu();
	    }
	};

	function closeMenu() {
		setTimeout(function(){
			menu.classList.remove('active');
			menuButton.classList.remove('active');
			clicked = false;
		}, 150);
	}
});

window.jQuery(function ($) {
	$('body').on('click', '.js-toggle-open', function () {
		$(this).parents('.panel').toggleClass('open');
	});
});

